<template>
  <div :class="['segment-component-container']">

    <div class="segment-input-component" :class="{selected}" @click="()=>enterPickerMode()" v-click-outside="{handler: onClickOutside,isActive:selected}">
      <div class="segment-input-wrapper" >
        <label>Segment:</label>
        <!-- {{fieldConfig.value[0].value}} -->
        <div class="pickers">
          <!-- <div class="crosshair-picker" :class="{active: pickingSegmentIndex===0}" @click="()=>enterPickerMode(i)"></div> -->
          <multi-select-component 
            :mode="maxSegments===1?'single':'multiple'" 
            :alwaysArray = true
            v-model="fieldConfig.value[0].value" 
            @input="onClickOutside"
            :options="getSegmentSelectOptions(fieldConfig)"
            :configurationOptions="{showMulipleValues:true}"/>
            <div class="all-none-buttons" v-if="maxSegments>1">
              <div class="all-button" @click="batchSelect(true)">Select all</div>
              <div class="separator"> - </div>
              <div @click="batchSelect(false)" class="none-button">Deselect all</div>
            </div>
        </div>
      </div>
      <div class="sub-fields">
        <sub-field-list-input-container v-for="subField in fieldConfig.value.slice(1)" :key="subField.id" :readOnly="readOnly" :fieldConfig="subField" :showTooltip="true"></sub-field-list-input-container>
      </div>
      
      <!-- {{fieldConfig}} -->
      <div class="delete-button" :class="{disabled: !canBeRemoved}" @click="onRemoveSegment"></div> 
    </div>
    
    <!-- <div class="add-button" v-if="canAddMoreSegments()" @click="onAddSegment">+ Add segment</div>
    <div class="no-more-add" v-else>Max {{maxSegments}} segments</div> -->
  </div>
</template>

<script>
import MultiSelectComponent from '@/components/MultiSelectComponent'
import { getValueTypeKey, validateSegmentList } from '@/utils/ConfigUtils'
import SubFieldListInputContainer from './SubFieldListInputContainer'
// import ClickOutside from 'vue-click-outside'

export default {
  name: 'SegmentsInputContainer',
  components: {MultiSelectComponent, SubFieldListInputContainer},
  // directives: {
  //   ClickOutside
  // },
  props: {
    fieldConfig: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    canBeRemoved: {
      type: Boolean,
      default: false
    }
  },
  model:{
    prop: 'fieldConfig',
    event: 'change'
  },
  data (){
    return {
      value: null,
      pickingSegmentIndex: null,
      selected: false
    }
  },
  mounted () {
  },
  computed: {
    maxSegments() {
      // return this.fieldConfig.segmentConfig.maxCount
      return this.fieldConfig.value[0].view.validate_max ? this.fieldConfig.value[0].view.validate_max : Infinity
    },
    minSegments() {
      return this.fieldConfig.value[0].view.validate_min ? this.fieldConfig.value[0].view.validate_min : 0
    }
  },
  methods: {
    enterPickerMode(segmentIndex){
      this.selected = true
      document.body.style.cursor = "crosshair"
      document.body.classList.add("crosshair");
      this.pickingSegmentIndex = segmentIndex
      this.$nextTick(()=>window.addEventListener('click',this.pickerCallback))
      setTimeout(()=>{
        this.$emit('pick-start',validateSegmentList(this.fieldConfig.value[0].view.validate_items))
      },10)
    },
    pickerCallback(e){
      // console.log("e.target", e.target)
      let id
      if(e.target.parentElement && e.target.parentElement.parentElement && e.target.parentElement.parentElement.__data__){
        id = e.target.parentElement.parentElement.__data__.id
      } else if (e.target.__data__) {
        id = e.target.__data__.id
      }
      // console.log("PICKED SEGMENT",id)
      if(id){
        if(this.maxSegments===1){
          this.fieldConfig.value[0].value = [id]
        } else {
          let arr = Array.isArray(this.fieldConfig.value[0].value)?this.fieldConfig.value[0].value:[this.fieldConfig.value[0].value]
          if(arr.indexOf(id)>=0) this.fieldConfig.value[0].value = arr.filter((d)=>d!==id)
          else this.fieldConfig.value[0].value = arr.concat([id])
        }
        // this.exitPickerMode()
      }
    },
    exitPickerMode(){
      this.selected = false
      document.body.style.cursor = 'inherit'
      document.body.classList.remove("crosshair");
      this.pickingSegmentIndex = null
      window.removeEventListener('click',this.pickerCallback)
      this.$emit('pick-end')
    },
    onClickOutside(e){
      //falta ver que pasa con "multiples" segments...
      if(e.target && e.target.closest('.cell')) return
      setTimeout(()=>this.exitPickerMode(),1)
      // this.exitPickerMode()
      // console.log("clickoutside",e)
    },
    getSegmentSelectOptions(targetSegment){
      // let allopts = validateSegmentList(this.fieldConfig.segmentConfig.segmentList)
      let allopts = validateSegmentList(this.fieldConfig.value[0].view.validate_items)
      // $isDisabled: true
      return allopts.map((o)=>{
        return {
          value: o,
          label: o,
          $isDisabled: false //this.fieldConfig.segmentList.find((s)=>s.segmentId === o) && targetSegment.segmentId !== o //BRING BACK
        }
      })
    },
    batchSelect(all){
      if(all){
        this.fieldConfig.value[0].value = this.getSegmentSelectOptions().map((d)=>d.value)
      } else {
        this.fieldConfig.value[0].value = []
      }
    },
    // onAddSegment(){
    //   let newSegment = {segmentId: null}
    //   if(this.fieldConfig.subFieldList){
    //     newSegment.subFieldList = JSON.parse(JSON.stringify(this.fieldConfig.subFieldList))
    //     newSegment.subFieldList.forEach((sf)=>{
    //       let key = getValueTypeKey(sf)
    //       sf.value = {}
    //       sf.value[key] = null
    //     })
    //   } else {
    //     newSegment.parameterConfig = JSON.parse(JSON.stringify(this.fieldConfig.parameterConfig))
    //     let key = getValueTypeKey(newSegment)
    //     newSegment.value = {}
    //     newSegment.value[key] = null

    //   }
    //   this.fieldConfig.value.push(newSegment)
    //   this.enterPickerMode(this.fieldConfig.segmentList.length-1)
    // },
    onRemoveSegment(){
      // this.fieldConfig.value = this.fieldConfig.value.filter((ss)=>ss!==s)
      this.$emit('remove',this.fieldConfig)
    },
    // canAddMoreSegments(){
    //   return this.fieldConfig.value.length < this.maxSegments
    // },
    // canRemoveSegment(){
    //   return this.fieldConfig.value[0].value.length > this.minSegments
    // }
  },
  watch:{
  }
}
</script>

<style lang="stylus">
.segment-component-container
  .segment-input-component
    display flex
    margin-bottom 10px
    border 2px solid #fff
    border-radius 3px
    padding 5px
    background #fff
    box-shadow 0 0 10px rgba($lynch, 0.25)
    &.selected
      border 2px solid #666
    .segment-input-wrapper
      display: flex
      flex-direction: column
      margin-right: 25px
      width 90px //un poco arbitrario...

      label
        color: #515662
        m-font-size(13, 14)
        margin-bottom: 4px
        text-transform: uppercase

      .pickers
        align-items: center
        display: flex
        flex-direction column
        margin-left 10px
        .multi-select-component
          flex: 1 1 auto
        .multiselect__tags
          max-width 80px
          min-width 80px
          overflow hidden
        .all-none-buttons
          display flex
          m-font-size(10,10)
          margin-top 3px
          .separator
            margin 0 2px
          div
            cursor pointer
            white-space nowrap
            &:hover
              text-decoration underline
    .sub-fields
      flex: 1 1 auto;
      display flex
      flex-direction row
      flex-wrap wrap
      .sub-field-list-input-container
        flex: 1 1 auto;
        width auto
        margin: 8px 0;
    .delete-button
      m-icon("cross", 20)
      flex: 0 0 20px; //forzamos el 20px tb en flex
      cursor: pointer
      margin-left: auto;
      margin-right: 10px;
      align-self: center;
      &.disabled
        opacity: 0.4
        pointer-events: none

    .multi-select-component
      >>> .multiselect__content-wrapper
        width: 100px

    .crosshair-picker
      background-image: url("~@/assets/icons/icon-selector.svg")
      background-position: center center
      background-repeat: no-repeat
      background-size: 15px 15px
      border: solid 1px $heather
      border-radius: 50%
      border-radius: 50%
      cursor: pointer
      display: block
      height: 28px
      margin-right: 10px
      width: 28px

      &.active
        background-color: #fff
        border: solid 1px $cloud-burst

  .add-button
    background: rgba(255, 255, 255, 0.5)
    border: 1px solid $cloud-burst
    border-radius: 20px
    // width 100px
    color: $cloud-burst
    cursor: pointer
    margin: 20px 0
    max-width: 150px
    padding: 7px
    text-align: center

    &:hover
      background: rgba(255, 255, 255, 0.9)

  .no-more-add
    m-font-size(12, 14)
    color: $heather
    text-transform: uppercase
</style>